import { computed, Injectable, signal, WritableSignal } from '@angular/core';
import { Tenant } from 'src/app/layout/modules/admin/admin.model';
import { AdminApiService } from 'src/app/layout/modules/admin/admin-api.service';
import { ClientDetails } from 'src/app/layout/modules/admin/pages/client-management/client.model';
import {
  AccessibleTenants,
  TenantDetails,
} from 'src/app/layout/modules/admin/pages/tenant-management/tenants/tenant.model';

import { AccessibleTenant } from '../models/user';

export type GroupedTenant = {
  value: number;
  items: AccessibleTenants[];
  label: string;
};
@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private _currentTenant: WritableSignal<Tenant | null> = signal(null);
  private _tenants: WritableSignal<Tenant[]> = signal([]);
  private _tenantClients: WritableSignal<ClientDetails[]> = signal([]);
  private _groupedAccessibleTenant: WritableSignal<GroupedTenant[]> = signal(
    []
  );

  public currentTenant = computed(() => this._currentTenant());
  public tenants = computed(() => this._tenants());
  public tenantClients = computed(() => this._tenantClients());
  public groupedAccessibleTenant = computed(() =>
    this._groupedAccessibleTenant()
  );

  constructor(private adminApiService: AdminApiService) {}

  async refreshTenants(accessibleTenants: AccessibleTenant[]) {
    this._tenants.set(accessibleTenants);
    const currentTenant = accessibleTenants.find((t) => t.isCurrentTenant);
    if (currentTenant) {
      this._currentTenant.set(currentTenant);
      const clients = await this.adminApiService.getTenantClient(
        currentTenant.tenantId
      );
      this._tenantClients.set(clients);
      if (currentTenant.name === 'a360 Inc') {
        const allTenantList: TenantDetails[] =
          await this.adminApiService.getTenantList();
        const activeTenantList: AccessibleTenants[] = allTenantList.reduce(
          (filteredTenantList: AccessibleTenants[], currentTenant) => {
            if (currentTenant.status === 'Active') {
              filteredTenantList.push({
                tenantTypeId: currentTenant.tenantTypeId,
                tenantType: currentTenant.tenantTypeName,
                tenantId: currentTenant.id,
                name: currentTenant.name,
              });
            }
            return filteredTenantList;
          },
          []
        );
        this.setDisplayTenantList(activeTenantList);
      } else {
        this.setDisplayTenantList(accessibleTenants);
      }
    }
  }

  setDisplayTenantList(displayTenantList: AccessibleTenants[]) {
    const groupedTenants = displayTenantList.reduce<{
      [key: number]: AccessibleTenants[];
    }>((acc, obj) => {
      const key = obj.tenantTypeId;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
    const groupedTenantArray = Object.entries(groupedTenants).map(
      ([tenantTypeId, objects]) => ({
        value: parseInt(tenantTypeId),
        items: objects,
        label: objects[0].tenantType,
      })
    );
    this._groupedAccessibleTenant.set(groupedTenantArray);
  }
}
